export default "__VITE_PUBLIC_ASSET__29ffef49__"